export type Region = "us" | "ca";

export const FOCAL_PHONE_CONFIG: Record<
  Region,
  { number: string; qrCode: string; formatted: string }
> = {
  us: {
    number: "18665124949",
    formatted: "866-512-4949",
    qrCode: "/assets/qr-phone-us.png",
  },
  ca: {
    number: "18887023625",
    formatted: "888-702-3625",
    qrCode: "/assets/qr-phone-ca.png",
  },
};
